export default __webpack_public_path__ + "738e657c7e2ad616e400e692dbfa42ad.png";